import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import { useMemo } from "react"
import { useIntl } from "react-intl"
import { finderCustomerHostname } from "src/common/finderCustomerHostname.const"
import { getCustomerAppLanguageTags } from "src/common/getCustomerAppLanguageTags"

export const useFinderSearchUrls = (): { name: string; url: string }[] => {
	const { environment, marketplaceKey } = useDealerContext()
	const { formatDisplayName } = useIntl()

	const availableLocales = getCustomerAppLanguageTags(marketplaceKey)
	return useMemo(
		() =>
			availableLocales.map((availableLocale) => ({
				name:
					formatDisplayName(availableLocale, {
						type: "language",
					}) ?? availableLocale,
				url: `${finderCustomerHostname[environment ?? "local"]}/${marketplaceKey}/${availableLocale}/dealer/search`,
			})),
		[availableLocales, formatDisplayName, marketplaceKey, environment],
	)
}
